import React from 'react'
import PropTypes from 'prop-types'
import ScoreChart from './ScoreChart'
import formatDay from './formatDay'
import { cardModel } from './cardModel'
import {
  bureauName,
  fromReport,
  FIRST_REPORT,
  ON,
  NO_SCORE_TITLE,
  noScoreExplanation,
  lastScore,
} from './copy'

const BureauCard = ({ entry, showChart, compact = false }) => {
  const name = bureauName(entry.bureau)
  const model = cardModel(entry)
  const scored = entry.latest.score !== null && entry.latest.score !== undefined

  return (
    <article
      data-testid={`bureau-card-${entry.bureau}`}
      aria-label={name}
      className={`min-w-0 border border-divider rounded-2xl bg-surface shadow-subtle dark:shadow-none ${compact ? 'p-3.5' : 'p-5'}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-1.5">
        <p className="m-0 text-md font-semibold text-text-secondary">{name}</p>
        {model && (
          <span className="inline-flex items-center rounded-full bg-[var(--color-bg-subtle)] px-2.5 py-0.5 text-xs font-medium text-text-secondary">
            {model}
          </span>
        )}
      </div>
      {scored ? (
        <>
          <p className="m-0 pt-3 text-[32px] font-bold leading-[1.15] text-text-primary tabular-nums">{entry.latest.score}</p>
          <p className="m-0 pt-1 text-md text-text-secondary">{fromReport(formatDay(entry.latest.day))}</p>
          {entry.first && (
            <p className="m-0 mt-1.5 text-[13px] text-text-secondary">
              {FIRST_REPORT} <b className="font-semibold text-text-primary">{entry.first.score}</b> {ON} {formatDay(entry.first.day)}
            </p>
          )}
        </>
      ) : (
        <>
          <p className="m-0 pt-3 text-lg-18 font-semibold text-text-secondary">{NO_SCORE_TITLE}</p>
          <p className="m-0 pt-1.5 text-[13px] text-text-secondary">
            {noScoreExplanation(name, formatDay(entry.latest.day))}
          </p>
          {entry.lastScored && (
            <p className="m-0 pt-1.5 text-[13px] text-text-secondary">
              {lastScore(name, entry.lastScored.score, formatDay(entry.lastScored.day))}
            </p>
          )}
        </>
      )}
      {entry.showChart && showChart && (
        <div className="mt-3.5 min-w-0">
          <ScoreChart points={entry.points} />
        </div>
      )}
    </article>
  )
}

BureauCard.propTypes = {
  entry: PropTypes.object.isRequired,
  showChart: PropTypes.bool,
  compact: PropTypes.bool,
}

export default BureauCard
